import DocumentUtils from '@/utils/document-utils';

export default class Cookie {
  public static getCookie(name:string) {
    let cName;
    const re = new RegExp(`${name}=([^;']+)`);

    cName = re.exec(DocumentUtils.getCookie());
    if (cName) {
      cName = cName[1].replace(/["']/g, '');
    }
    return cName;
  }
}
